<div class="card module-card shadow-sm mb-4">
    <div class="card-header bg-white d-flex align-items-center">
        <i class="fas fa-project-diagram text-primary mr-2"></i>
        <h5 class="mb-0 text-primary">Modules</h5>
    </div>

    <ngb-accordion #acc="ngbAccordion" class="custom-accordion" [closeOthers]="true">
        <ngb-panel *ngFor="let mod of modules" [id]="mod.module">

            <!-- Título con icono giratorio -->
            <ng-template ngbPanelTitle>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <span>{{ mod.module | titlecase }}</span>
                    <i class="fas fa-chevron-down chevron"></i>
                </div>
            </ng-template>

            <!-- Contenido -->
            <ng-template ngbPanelContent>
                <h6 class="text-primary">{{ mod.section }}</h6>
                <div *ngFor="let setting of mod.settings" class="row align-items-center mb-3">

                    <!-- Label -->
                    <label class="col-md-4 font-weight-bold mb-0">
                        {{ setting.label }}
                    </label>

                    <div class="col-md-8">
                        <ng-select
                                *ngIf="setting.type === 'select'"
                                [(ngModel)]="setting.value"
                                [multiple]="true"
                                [appendTo]="'body'"
                                [dropdownPosition]="'bottom'"
                                bindLabel="label"
                                bindValue="value"
                                >

                            <ng-option
                                    *ngFor="let opt of setting.optionsList"
                                    [value]="opt.value">
                                {{ opt.label }}
                            </ng-option>

                        </ng-select>
                        <input *ngIf="setting.type === 'input'"
                               type="text"
                               class="form-control"
                               [(ngModel)]="setting.value" />

                        <div *ngIf="setting.type === 'checkbox'" class="form-check form-switch">
                            <input class="form-check-input"
                                   type="checkbox"
                                   [(ngModel)]="setting.value" />
                        </div>

                        <div *ngIf="setting.type === 'fileJson'" class="file-json-container">
                            <div class="d-flex align-items-center">
                                <!-- Input a la izquierda -->
                                <label class="btn btn-outline-primary mb-2 me-2" for="customFileInput">
                                    <i class="fas fa-file-excel"></i> Select Excel file
                                </label>

                                <input type="file"
                                       id="customFileInput"
                                       accept=".xlsx, .xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                       (change)="onExcelImport($event, setting)"
                                       class="form-control-file me-2 d-none"  />

                                <!-- Icono a la derecha -->
                                <i class="fas fa-question-circle ml-2"
                                   [ngbTooltip]="customTooltip"
                                   triggers="click"
                                   placement="top"
                                   container="body"
                                   [tooltipClass]="'my-custom-tooltip'"
                                   style="cursor: pointer;"></i>
                            </div>

                            <ng-template #customTooltip>
                                <div class="text-dark">
                                    <div class="card-body p-3">
                                        <h6 class="card-title mb-2"><strong>Valid format for Column A:</strong></h6>

                                        <img [src]="'assets/img/img.png'" alt="Excel Example" class="img-fluid rounded mb-2" style="max-height: 100px;">

                                        <p class="card-text mb-2">
                                            Only <code class="text-danger">.xls</code> or <code class="text-danger">.xlsx</code> files are supported.
                                        </p>

                                        <p class="card-text mb-0 text-success">
                                            <i class="fas fa-file-excel me-1"></i> Excel format
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="d-flex mb-2">
                                <input type="text" #inputItem class="form-control mr-2" placeholder="New CapitalOneBin" />
                                <button (click)="addItem(setting, inputItem.value); inputItem.value=''" class="btn btn-sm btn-success">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                            <ul class="item-list">
                                <li *ngFor="let item of getPagedItems(setting); let i = index" class="item">
                                    <span class="item-value">• {{ item }}</span>
                                    <button (click)="removeSetting(setting, i)" class="btn btn-danger">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </li>
                            </ul>

                            <div class="pagination-controls" *ngIf="parseJson(setting.value).length > pageSize">
                                <button (click)="prevPage()" [disabled]="page === 1" class="btn btn-secondary">
                                    <i class="fas fa-arrow-left"></i>
                                </button>

                                <button (click)="nextPage(setting)" class="btn btn-secondary">
                                    <i class="fas fa-arrow-right"></i>
                                </button>

                                <span class="page-info">Page {{ page }}</span>
                            </div>

                            <div class="total-records">
                                <strong>Total Records:</strong> {{ parseJson(setting.value).length }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <button mat-flat-button class="btn btn-sm btn-primary" (click)="updateSetting(mod)">
                        <mat-icon class="mr-2">save</mat-icon> Update
                    </button>
                </div>
            </ng-template>

        </ngb-panel>
    </ngb-accordion>
</div>